import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

function customCursor() {
    
    function updateCustomCursorPosition(e, customCursor, parentClass, offset) {
      let { pageX, pageY, target } = e;

      if (target.matches(parentClass) || target.closest(parentClass)) {
        // pageY = pageY - offset;
        // console.info(pageY);
        gsap.to(customCursor, {
          x: pageX,
          y: pageY,
          duration: 0.3,
        });
      }

      updateCustomCursorStyle(e, customCursor, parentClass);
    }

    function updateCustomCursorStyle(e, customCursor, parentClass, offset) {
      // add custom styles to the cursor based on the target of the mouse during the mouseover event

      const { target } = e;
      const { classList } = customCursor;
      const body = document.querySelector("body");

      // check if data-js="navigation"

      if (
        (target.matches(parentClass) || target.closest(parentClass)) &&
        !classList.contains("force-hide") &&
        !target.closest('[data-js="navigation]')
      ) {
        classList.add("opacity-100");
        classList.remove("opacity-0");
        body.style.cursor = "none";
      } else {
        classList.add("opacity-0");
        classList.remove("opacity-100");

        body.style.cursor = "auto";
      }
    }

    function Cursor(cursor, parentClass) {
      // - cursor element hidden on all pages
      // - add hover event listener to all elements that should show mouse when hovered over
      // - if hovering over an element, display cursor element

      const yOffset = 0;
      // const bodyRect = document.body.getBoundingClientRect();
      // 	const elemRect = document.querySelector(parentClass).getBoundingClientRect()
      // 	// const yOffset = elemRect.top - bodyRect.top
      // 	const yOffset = window.pageYOffset + document.querySelector(parentClass).getBoundingClientRect().top;
      if (!cursor || window.matchMedia("(max-width: 768px)").matches) return;

      document.addEventListener(
        "mousemove",
        function (e) {
          updateCustomCursorPosition(e, cursor, parentClass, yOffset);
        },
        false
      );

      document.addEventListener(
        "wheel",
        function (e) {
          updateCustomCursorPosition(e, cursor, parentClass, yOffset);
        },
        false
      );
    }

    if (
      document.querySelectorAll('[data-js="custom-cursor-contain-video"]').length
    ) {         
      Cursor(
        document.querySelector('[data-js="custom-cursor-video"]'),
        '[data-js="custom-cursor-contain-video"]'
      );
    }
    if (
      document.querySelectorAll('[data-js="custom-cursor-contain-qa"]').length
    ) {         
      Cursor(
        document.querySelector('[data-js="custom-cursor-qa"]'),
        '[data-js="custom-cursor-contain-qa"]'
      );
    }
    if (
      document.querySelectorAll('[data-js="custom-cursor-contain-whykps"]').length
    ) {         
      Cursor(
        document.querySelector('[data-js="custom-cursor-whykps"]'),
        '[data-js="custom-cursor-contain-whykps"]'
      );
    }
}

export default customCursor;